import { Link, LinkProps } from "@tanstack/react-router";
import { useUser } from "hooks/useUser.ts";
import React, { MouseEventHandler } from "react";

export interface TenantLinkProps extends Omit<LinkProps, "to" | "params"> {
    to?: string;
    params?: { [key: string]: string };
    search?: Record<string, string | number | boolean> | ((prev: Record<string, unknown>) => Record<string, unknown>);
    children: React.ReactNode;
    className?: string;
    onMouseDown?: MouseEventHandler<HTMLAnchorElement>;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export const TenantLink = ({ to, params, search, children, ...props }: TenantLinkProps) => {
    const userUtils = useUser();

    const tenantSlug = userUtils.getActiveTenant()?.slug_name;

    if (!tenantSlug) {
        return null;
    }

    return (
        <Link
            to={`/${tenantSlug}${to ?? ""}` as unknown as LinkProps["to"]}
            params={{ tenantSlug, ...params }}
            search={search as unknown as LinkProps["search"]}
            {...props}
        >
            {children}
        </Link>
    );
};
